// @flow

import type { JSONValue, JSONArray } from 'common/types';

export default function items<V>(
  extract: JSONValue => V
): JSONArray => Array<V> {
  return array => array.map(extract);
}
